import React from 'react';
import { FiArrowDown, FiArrowUpRight, FiDownload, FiGithub, FiLinkedin } from 'react-icons/fi';

export default function Home() {
  return (
    <section className="hero" id="Home">
      <div className="hero__glow hero__glow--one" /><div className="hero__glow hero__glow--two" />
      <div className="hero__content">
        <div className="hero__copy">
          <div className="availability hero-reveal"><span /> Available for impactful opportunities</div>
          <p className="eyebrow hero-reveal">FULL-STACK SOFTWARE DEVELOPER · INDIA</p>
          <h1 className="hero-reveal">I build digital products that feel <em>fast, clear, and human.</em></h1>
          <p className="hero__lede hero-reveal">3+ years shipping production B2B and B2C products with React, Next.js, Node.js and ASP.NET—turning complex workflows into reliable experiences.</p>
          <div className="hero__actions hero-reveal">
            <a className="button button--primary" href="#Project">Explore my work <FiArrowDown /></a>
            <a className="button button--ghost" href="/Himanshu_Singh_Developer.pdf" download>Resume <FiDownload /></a>
          </div>
          <div className="hero__social hero-reveal">
            <a href="https://github.com/Himanshu5296" target="_blank" rel="noreferrer"><FiGithub /> GitHub</a>
            <a href="https://linkedin.com/in/himanshusingh52" target="_blank" rel="noreferrer"><FiLinkedin /> LinkedIn</a>
            <a href="mailto:himanshu.singh5296@gmail.com">Email <FiArrowUpRight /></a>
          </div>
        </div>
        <div className="hero__visual hero-reveal" aria-hidden="true">
          <div className="orbit orbit--one"><span>React</span></div>
          <div className="orbit orbit--two"><span>Node</span></div>
          <div className="orb">
            <div className="orb__grid" />
            <div className="orb__core"><span>3+</span><small>YEARS<br/>BUILDING</small></div>
          </div>
          <div className="float-card float-card--top"><i /> Production-minded</div>
          <div className="float-card float-card--bottom"><strong>20%</strong><span>faster page loads</span></div>
        </div>
      </div>
      <div className="hero__proof hero-reveal">
        <div><strong>5+</strong><span>production features delivered</span></div>
        <div><strong>35%</strong><span>fewer redundant API calls</span></div>
        <div><strong>4+</strong><span>third-party integrations</span></div>
        <p>Performance · Systems · Product thinking</p>
      </div>
    </section>
  );
}
